package app.nestbridge.feature.careteam.model

import kotlinx.serialization.Serializable

@Serializable
enum class TeamRelationshipRole {
    ORGANIZER,
    THERAPIST,
    PARENT,
    OBSERVER,
}
